import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

export default createUseStyles({
  container: {
    width: '30vw',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column'
  },
  closeBtn: {
    marginRight: -12
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: 20,
    borderBottom: `1px solid ${THEME.brandBorderGrey}`,
    padding: '8px 16px',
    flexShrink: 0
  },
  content: {
    overflowY: 'auto'
  },
  '@media (max-width: 760px)': {
    container: {
      width: 'calc(100vw - 48px)',
      maxWidth: '400px'
    }
  }
})
